// Desc: API Base URL process.env.REACT_APP_API_BASE_URL
export const API_BASE_URL = 'https://backend.truklex.com/api/admin/';

// Desc: API Endpoints
export const LOGIN_ENDPOINT = `login`;
export const FORGOT_ENDPOINT = `forgot-password`;
export const PROFILE_ENDPOINT = `profile`;
export const UPDATE_PROFILE_ENDPOINT = `update-profile`;
export const CHANGE_PROFILE_ENDPOINT = `change-password`;
export const ARTICLE_CATEGORIES_ENDPOINT = `articles/categories`;
export const ARTICLE_SOURCES_ENDPOINT = `articles/sources`;
export const ARTICLE_AUTHORS_ENDPOINT = `articles/authors`;
export const ARTICLES_ENDPOINT = `articles`;
export const UPDATE_PREFERENCES_ENDPOINT = `update-preferences`;
